module.exports = __webpack_public_path__ + "static/media/reload.86b66d78.svg";